<div class="test" *ngIf="title=='Pinap'" style="background-color: teal; color: white">{{'This is trash'}}</div>


<p>{{title}} works!</p>

<button>Dont touch me</button>